import { render, staticRenderFns } from "./PriceWarn.vue?vue&type=template&id=5133087c&scoped=true&"
import script from "./PriceWarn.vue?vue&type=script&lang=js&"
export * from "./PriceWarn.vue?vue&type=script&lang=js&"
import style0 from "./PriceWarn.vue?vue&type=style&index=0&id=5133087c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5133087c",
  null
  
)

export default component.exports